import { get } from "../../config/api";

export const Transaction = {
  getAll: (limit = 10, page = 1) =>
    get(`transactions?page=${page}&limit=${limit}`),
};
